import script from "./RoomOtherComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomOtherComponent.vue?vue&type=script&setup=true&lang=js"

import "./RoomOtherComponent.vue?vue&type=style&index=0&id=4e126ed6&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-rsmelinda2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e126ed6"]])

export default __exports__